import { create } from 'zustand';

export const useUIStore = create((set) => ({
  showMobileMenu: false,
  setShowMobileMenu: (show) => set({ showMobileMenu: show }),
}));
